import axios from "axios";
import API_KEY from "api";

const pythonBaseUrl = process.env.REACT_APP_API_SERVICE;

export const getProductDetailsV2 = (id) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.get(
		`${process.env.REACT_APP_API_SERVICE}items/productsv2/?id=${id}&token=${token}`
	);
};

export const getAccountDetails = (token) => {
	if (!token) {
		const user = localStorage.getItem("user");
		token = JSON.parse(user)?.access_token;
	}
	return axios.get(`${pythonBaseUrl}user/me?access_token=${token}`);
};

export const getCountryCodes = () => {
	return axios.get(`${pythonBaseUrl}auth/country_codes`);
};

export const updateMobileNumber = (data, token) => {
	if (!token) {
		const user = localStorage.getItem("user");
		token = JSON.parse(user)?.access_token;
	}
	return axios.post(`${pythonBaseUrl}auth/update_mobile`, data, {
		headers: { "access-token": `${token}` },
	});
};

export const updateAccountDetails = (userId, data) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;

	return axios.patch(`${process.env.REACT_APP_DIRECTUS}users/${userId}`, data, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const getCompanyDetails = (id) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.get(
		`${process.env.REACT_APP_DIRECTUS}items/manufacturer/${id}?access_token=${token}`
	);
};

export const updateCompanyDetails = (id, data) => {
	console.log("data:", data);
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;

	return axios.patch(
		`${process.env.REACT_APP_DIRECTUS}items/manufacturer/${id}`,
		data,
		{
			headers: { Authorization: `Bearer ${token}` },
		}
	);
};

export const getLinkSecurityData = (collectionLink) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.get(
		`${process.env.REACT_APP_API_SERVICE}link_security/?token=${token}&collection_link=${collectionLink}`
	);
};

export const createLinkSecurityData = (collectionLink, collectionId, data) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.post(
		`${process.env.REACT_APP_API_SERVICE}link_security/create/?token=${token}&collection_link=${collectionLink}&collection_id=${collectionId}`,
		data
	);
};

export const updateLinkSecurityData = (id, data) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.put(
		`${process.env.REACT_APP_API_SERVICE}link_security/update/${id}?token=${token}`,
		data
	);
};
